export const CURRENCIES = ['USD', 'GBP', 'AUD', 'CAD', 'EUR', 'JPY', 'NZD']
